import axios from 'axios';

const request = ({
  method,
  url,
  headers,
  data,
  params,
  exceptionHandler,
  loaderSetterFunction,
}) => {
  const config = {
    method: method || 'get',
    baseURL: url,
    data: data || null,
    params: params || null,
    timeout: 7000,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  };

  if (loaderSetterFunction) loaderSetterFunction(true);

  return axios(config)
    .then(response => {
      if (loaderSetterFunction) loaderSetterFunction(false);
      return response.data;
    })
    .catch(error => {
      if (loaderSetterFunction) loaderSetterFunction(false);

      if (exceptionHandler) {
        exceptionHandler();
      } else {
        // throw new Error(`Request error: ${error.message}`);
        console.log(error);
      }
    });
};

export default request;
